import moment, { type Moment } from 'moment';

export const ENTRY_DATE_FORMAT = 'DD/MM/YYYY HH:mm';

/**
 * Data e hora de entrada do veículo (`entryDate`).
 * A API devolve em UTC, às vezes sem o sufixo `Z` (mesmo tratamento de `formatDateTimeWithTimezone`).
 * Retorna no fuso local.
 */
export const parseEntryDate = (value?: string | Moment | null): Moment | null => {
    if (!value) {
        return null;
    }

    const date = moment.isMoment(value) ? value.clone() : moment.utc(value).local();

    return date.isValid() ? date : null;
};

/** Normaliza o valor vindo da API para ISO em UTC (com `Z`), ou '' se vazio/inválido. */
export const normalizeEntryDate = (value?: string | null): string =>
    parseEntryDate(value)?.toISOString() ?? '';

/** Converte o valor do DatePicker (Moment ou texto digitado) para ISO em UTC, sem segundos. */
export const toEntryDateValue = (value: Moment | string): string => {
    const date = moment.isMoment(value) ? value.clone() : moment(value, ENTRY_DATE_FORMAT, true);

    return date.isValid() ? date.startOf('minute').toISOString() : '';
};

export const formatEntryDate = (value?: string | Moment | null): string | undefined =>
    parseEntryDate(value)?.format(ENTRY_DATE_FORMAT);

export const entryDatesAreEqual = (current?: string | null, original?: string | null): boolean => {
    const currentDate = parseEntryDate(current);
    const originalDate = parseEntryDate(original);

    if (!currentDate || !originalDate) {
        return !currentDate && !originalDate;
    }

    return currentDate.isSame(originalDate, 'minute');
};
